import { _ } from "../../core/polyglot/polyglot.js";
import AccountingDocument from "../shared/documentInfrastructure/AccountingDocument2/AccountingDocument.js";
import CompanySettingsForecastWizardDocumentCoordinator from "./CompanySettingsForecastWizardDocumentCoordinator.js";
import ForecastOnBoardingDocumentContent from "../forecastOnBoarding/ForecastOnBoardingDocumentContent/ForecastOnBoardingDocumentContent.js";
import ForecastOnBoardingDocumentService from "../forecastOnBoarding/ForecastOnBoardingDocumentService.js";
import ForecastOnBoardingDocumentState from "../forecastOnBoarding/ForecastOnBoardingDocumentState.js";
import session from "../../core/session.js";
import TitleWidget from "../../core/chrome/TitleWidget2.js";

/**
 * Glue together all the parts for creating a document for running a
 * forecast wizard to update default company settings.
 */
export default function makeCompanySettingsForecastWizardDocument() {
	const coordinator = new CompanySettingsForecastWizardDocumentCoordinator({
		documentState: new ForecastOnBoardingDocumentState({
			service: new ForecastOnBoardingDocumentService({ session }),
		}),
		renderables: {
			content: new ForecastOnBoardingDocumentContent(),
			title: new TitleWidget({ title: _("Forecast OnBoarding") }),
			periodPicker: false,
		},
	});

	return new AccountingDocument({
		coordinator,
		cssClass: "forecast-onboarding full-page",
	});
}
